import { Area } from 'types/area'

// A selectable area (leaf with sources) flattened out of the nested tree, carrying its full
// ancestor path (names) so the picker can show "Parent › Child". Parent-only and empty areas
// are excluded — they are not valid chat targets.
export type AreaOption = {
  area: Area
  path: string[]
}

export const getSelectableAreaOptions = (areas?: Area[], parents: string[] = []): AreaOption[] =>
  (areas ?? []).flatMap((area) => {
    const path = [...parents, area.name]
    // An area with its own sources is selectable AS ITSELF; its sub-areas are ALSO listed.
    // So a parent that has both sources and children yields both its own option and its children's.
    const self: AreaOption[] = area.numberOfAreaSources > 0 ? [{ area, path }] : []
    return [...self, ...getSelectableAreaOptions(area.children, path)]
  })
